// bao migrate skip
// bao migrate - module not found: import IMessageBusEventHandler from "message-bus/imessage-bus-event-handler";
import "./../services/app-tab-controller";
import "./../bindings/bao-toolbar2";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-date-time-box";
import "./../bindings/element";
import "./../bindings/filtering";
import SubscriptionViewModel from "./../factories/subscription-view-model";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import * as moment from "moment";
import BaoDialogViewModel from "./../factories/bao-dialog";
import Guid from "./../factories/guid";
import finitoService from "./../services/finito-service";
import TabPage from "./../factories/tab-page";
import SendMailDialog from "./../factories/send-mail-dialog";
import BaoDialog from "./../factories/bao-dialog";
import InformationHistoryViewModel from "./information-history";
import baoRouter from "./../services/bao-router";
import MessageBus, { IMessageBusEventHandler } from "./../services/message-bus";
import AppTabController from "./../services/app-tab-controller";
export class InfoTemplateDialog {
    constructor(tabPage) {
        this.TabPage = tabPage;
    }
    TabPage = null;
    Dialog = null;
    Bao = Bao;
    SelectedItem = ko.observable();
    Items = ko.observableArray();
    Deferred = $.Deferred();
    SelectItem(item) {
        this.Deferred.resolve(item);
        if (this.Dialog != null && this.Dialog.Close != null) {
            this.Dialog.Close();
        }
    }
    ;
    OpenDialog(shiftbookId) {
        Bao.post("MasterData/InfoTemplate/SelectInfoTemplateDialog", JSON.stringify({ shiftbookId: shiftbookId }), (result) => {
            // with model.length > 1 instead of 0, we skip the empty template. If there is NO empty template, users will have to have at least 2 templates for this screen to show up!
            if (result.Models != null && result.Models.length > 1) {
                this.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
                this.Items(result.Models);
                this.Dialog.ViewModel(this);
                this.Dialog.Buttons([
                    {
                        Title: Bao.Session.GetMessage("msgOk"),
                        Click: () => {
                            this.Deferred.resolve(this.SelectedItem());
                            this.Dialog.Close();
                        },
                        Enabled: ko.observable(true)
                    },
                    {
                        Title: Bao.Session.GetMessage("msgCancel"),
                        Click: () => {
                            this.Deferred.resolve();
                            this.Dialog.Close();
                        },
                        Enabled: ko.observable(true)
                    }
                ]);
                this.Dialog.Closed = () => {
                    this.Deferred.resolve();
                };
                this.Dialog.Template(result.Message);
                this.Dialog.Open();
            }
            else {
                this.Deferred.resolve(false);
            }
            this.TabPage.IsLoading(false);
        });
        return this.Deferred.promise();
    }
    ;
}
class InformationViewModel extends SubscriptionViewModel {
    constructor(tabPage, shiftReportViewModel) {
        super(tabPage);
        this.ShiftReport = shiftReportViewModel;
        this.ToolbarButtons = (<any>this.TabPage).ToolbarButtons;
        this.selectedState.subscribe((item) => {
            let id = item[0];
            for (let i = 0; i < this.States().length; i++) {
                if (this.States()[i].InfoStateId() == id) {
                    this.InfoStateColor(this.States()[i].Color());
                }
            }
        });
        this.Device4Id.subscribe(() => {
            if (!this.TabPage.IsLoading())
                this.SetParentsByDevice4();
        });
        this.Device4NameBinding.subscribe(() => {
            if (!this.TabPage.IsLoading() && this.Device4Id() != null) {
                this.Device4Id(null);
            }
        });
        this.Device3Id.subscribe(() => {
            if (!this.TabPage.IsLoading())
                this.SetParentsByDevice3();
        });
        this.Device3NameBinding.subscribe(() => {
            if (!this.TabPage.IsLoading() && this.Device3Id() != null) {
                this.Device3Id(null);
            }
        });
        this.AreaEquipmentId.subscribe(() => {
            if (!this.TabPage.IsLoading())
                this.SetParentsByAreaEquipment();
        });
        this.AreaEquipmentBinding.subscribe(() => {
            if (!this.TabPage.IsLoading() && this.AreaEquipmentId() != null) {
                this.AreaEquipmentId(null);
            }
        });
        this.AreaId.subscribe(() => {
            if (!this.TabPage.IsLoading())
                this.SetChildrenByArea();
        });
        //
        // Textbaustein einfügen
        this.SelectedTextModule.subscribe((selectedTextModule: any) => {
            finitoService.InsertAtCursorPositionContentEditable(this.TextModuleField().querySelector("#userTaggingInput"), selectedTextModule.Text);
        });
        this.subscribe(this.ShiftReport.IsOriginal, (isOriginal) => {
            this.TabPage.IsLoading(true);
            if (isOriginal) {
                this.get(isOriginal)
                    .then(() => {
                        finitoService.setTextToUserTaggingInput(this.TextModuleField().querySelector("#userTaggingInput"), this.InfoText(), isOriginal);
                        this.toggleButtons();
                        this.setTabTitle();
                    })
                    .always(() => this.TabPage.IsLoading(false));
            }
        })

        this.subscribe(this.ShiftReport.CurrentRevision, (isOriginal) => {
            this.TabPage.IsLoading(true);
            if (isOriginal) {
                this.get(false)
                    .then(() => {
                        finitoService.setTextToUserTaggingInput(this.TextModuleField().querySelector("#userTaggingInput"), this.InfoText(), false);
                        this.toggleButtons();
                        this.setTabTitle();
                    })
                    .always(() => this.TabPage.IsLoading(false));
            }
        })

        this.subscribe(this.ShiftReport.IsShiftClosure, (value) => {
            if (value) {
                this.get(false)
                    .then(() => {
                        finitoService.setTextToUserTaggingInput(this.TextModuleField().querySelector("#userTaggingInput"), this.InfoText(), true);
                        this.toggleButtons();
                        this.setTabTitle();
                    })
                    .always(() => this.TabPage.IsLoading(false));
            }
        });
        //
        // Dateianhänge
        this.InfoAttachment["Filtered"] = ko.pureComputed(() => {
            let infoAttachment = this.InfoAttachment(), revision = this.Revision();
            if (!isNaN(revision)) {
                return ko.utils.arrayFilter(infoAttachment, (att: any) => {
                    return att.DeleteInRevision() === null || (att.DeleteInRevision() > this.Revision());
                });
            }
            else {
                return infoAttachment;
            }
        });
        Bao.bindEvent('user-tagging:loaded', (value) => {
            this.checkUserTaggingValue(value.id);
        });
    }
    baoToolbar2ShowButton: (actionKey: string, visible: boolean) => void;
    baoToolbar2LinkItemsShowButton: (actionKey: string, visible: boolean) => void;
    baoToolbar2InformationEvaluationShowButton: (actionKey: string, visible: boolean) => void;

    ElementDateTimePickerStart = ko.observable();
    ElementDateTimePickerEnd = ko.observable();
    ShowStatusDialog = ko.observable();
    ToolbarButtons = null;
    ShiftReport = null;
    TextModuleField = ko.observable();
    Priorities = ko.observableArray();
    States = ko.observableArray<{
        InfoStateId: KnockoutObservable<string>;
        Color: KnockoutObservable<string>;
    }>();
    selectedState = ko.observableArray();
    InfoStateColor = ko.observable();
    Categories = ko.observableArray();
    InfoTags = ko.observableArray();
    InfoId = ko.observable();
    Duration = ko.observable();
    Revision = ko.observable<number>();
    InfoAttachment = ko.observableArray<any>().extend({ dirty: this.TabPage.DirtyFlag });
    InfoTag = ko.observableArray([]).extend({ dirty: this.TabPage.DirtyFlag });
    SelectedTextModule = ko.observable();
    showAttachmentDialog = () => { };
    showTextModuleDialog = () => { };
    uploadAttachment = () => { };
    PermissionPrefix = null;
    PagingEnabled = ko.observable(true);
    IsHistory: KnockoutObservable<boolean>;
    CategoryStructureId: KnockoutObservable<string>;
    InfoNr: KnockoutObservable<number>;
    InfoText: KnockoutObservable<string>;
    InfoStateId: KnockoutObservable<string>;
    InfoLevelId: KnockoutObservable<string>;
    HasHistory: KnockoutObservable<boolean>;
    IsNew: KnockoutObservable<boolean>;
    IsOriginal: KnockoutObservable<boolean>;
    SaveAllowed: KnockoutObservable<boolean>;
    StartDateHtml: KnockoutObservable<string> = ko.observable("");
    EndDateHtml: KnockoutObservable<string>;
    CategoryFullName: KnockoutObservable<string>;
    InfoStateText: KnockoutObservable<string>;
    InfoLevelText: KnockoutObservable<string>;
    TabName: KnockoutObservable<string>;
    ReportId: KnockoutObservable<string>;
    InfoSapId: KnockoutObservable<string>;
    HasSapNumber = ko.observable(false);
    InfoHistoryId: KnockoutObservable<string>;
    SyncId: KnockoutObservable<number>;
    Confidential: KnockoutObservable<boolean>;
    RawValue: KnockoutObservable<string> = ko.observable("")
    UserTaggingList: KnockoutObservableArray<string> = ko.observableArray([]);
    showUserTaggingControl: KnockoutObservable<boolean> = ko.observable(true);
    SystemSettingNotifyWhenAddEventToClosedReport = ko.observable(false);
    /**
     * will be set by baoToolbar2 Binding
     */
    enableButton: (actionKey: string, enable: boolean) => void;
    AreaId = ko.observable().extend({ dirty: this.TabPage.DirtyFlag });
    AreaName = ko.observable<string>().extend({ dirty: this.TabPage.DirtyFlag });
    AreaEquipmentId = ko.observable().extend({ dirty: this.TabPage.DirtyFlag });
    AreaEquipmentBinding = ko.observable<string>().extend({ dirty: this.TabPage.DirtyFlag });
    Device3NameBinding = ko.observable<string>().extend({ dirty: this.TabPage.DirtyFlag });
    Device3Id = ko.observable().extend({ dirty: this.TabPage.DirtyFlag });
    Device4NameBinding = ko.observable().extend({ dirty: this.TabPage.DirtyFlag });
    Device4Id = ko.observable().extend({ dirty: this.TabPage.DirtyFlag });
    Loss = ko.observable().extend({ dirty: this.TabPage.DirtyFlag });
    SubTabsSaveFn = [];
    SubTabsCompleteCheckFn = [];
    IgnoreDeviceChanges = ko.observable(true);
    SessionTabId: KnockoutObservable<string>;
    notifyInfoChangedHandler: IMessageBusEventHandler = {
        name: 'notifyInfoChanged',
        handler: (result: {
            id: string;
            newSyncId: number;
            excludeUserId: string;
        }) => this.checkAndShowNotifyIfRecordChanged(result.id, result.newSyncId, result.excludeUserId)
    };

    Focus = () => { };
    //
    // setzt die session zurück
    ResetSession(): JQueryPromise<any> {
        if (this.ElementDateTimePickerStart() !== undefined) {
            if ($(this.ElementDateTimePickerStart()).parent().data("DateTimePicker") !== undefined) {
                $(this.ElementDateTimePickerStart()).parent().data("DateTimePicker").date(null);
            }
            if ($(this.ElementDateTimePickerEnd()).parent().data("DateTimePicker") !== undefined) {
                $(this.ElementDateTimePickerEnd()).parent().data("DateTimePicker").date(null);
            }
        }
        if (this.SessionTabId && ko.unwrap(this.SessionTabId).length > 0) {
            return Bao.post("Information/ResetSession", JSON.stringify({ sessionTabId: this.SessionTabId() }));
        }
        return $.Deferred<any>().resolve().promise();
    }
    ;
    getInfoAttachments() {
        return Bao.post("Information/GetAttachments", JSON.stringify({ sessionTabId: this.SessionTabId() }));
    }
    ;
    //
    // Dateianhang hinzufügen
    attachmentAdded = () => {
        this.TabPage.IsLoading(true);
        this.TabPage.DirtyFlag(true);
        this.getInfoAttachments()
            .done((data) => {
                ko.map.fromJS(data, this.InfoAttachment);
                this.TabPage.IsLoading(false);
            });
    };
    //
    // Dateianhang entfernen
    removeAttachment = (attachment) => {
        if (!this.IsHistory()) {
            this.TabPage.IsLoading(true);
            this.TabPage.DirtyFlag(true);
            // setzte delete flag property
            attachment.DeleteInRevision(this.Revision());
            // set session info
            Bao.post("Information/RemoveAttachment", JSON.stringify({
                sessionTabId: this.SessionTabId(),
                attachmentId: attachment.InfoAttachmentId(),
                deleteInRevision: this.Revision()
            })).done(() => {
                this.TabPage.IsLoading(false);
            });
        }
    };
    //
    // Toolbar-LoadedHandler
    toolbarLoaded = () => {
        this.setPermissions();
        this.toggleButtons();
    };

    validateDate = () => {
        return Bao.post('Information/ValidateDate', JSON.stringify({
            reportId: this.ShiftReport.ReportId(),
            startDate: this.StartDateHtml(),
            endDate: this.EndDateHtml()
        }))
    }

    //
    // Toolbar-ClickHandler
    toolbarButtonClicked = (btn) => {
        if (this.TabPage != null && this.TabPage.IsActiveTab != null && this.TabPage.IsActiveTab() === true) {
            if ($.isFunction(btn.click)) {
                btn.click();
            }
            let actionFormName = 'action' + this.ShiftReport.FormName() + 'CustomToolbarActiveInfo';
            let functionString = btn.ActionKey().substr(actionFormName.length);
            switch (functionString) {
                case 'Save':
                    this.validateDate().then(res => {
                        if (res.Value === true) {
                            if ((this.TabPage.DirtyFlag() || this.IsNew()) && this.SaveAllowed() && !this.IsHistory()) {
                                this.validate().then((isValid) => {
                                    if (isValid) {
                                        this.checkThatShiftEventShouldBeTransferred()
                                            .then((transferInfo: boolean | null) => {
                                                if (transferInfo === null) {
                                                    return;
                                                }
                                                this.Save(transferInfo).then((saveResult) => this.afterSave(saveResult));
                                            });
                                    }
                                    else {
                                        this.showValidationErrors();
                                    }
                                });
                            }
                        } else {
                            new BaoDialog(Bao.Session.ApplicationName, res.Message, "info");
                        }
                    })

                    break;
                case 'Delete':
                    this["delete"]();
                    break;
                case 'Forward':
                    this.forward();
                    break;
                case 'Backward':
                    this.backward();
                    break;
                case 'Info':
                    this.info();
                    break;
                //neue Info
                case 'New':
                    if (!this.SystemSettingNotifyWhenAddEventToClosedReport() || this.ShiftReport.IsClosed() !== true) {
                        this.CreateNewInfo();
                        return;
                    }
                    // report is closed and system-setting for prompt is set to true, so ask if user really wants to add an info to a closed report
                    var yesnodialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.AddEventToClosedReport), 'yesno');
                    yesnodialog.DialogResult.subscribe((dialogresult) => {
                        if (dialogresult) {
                            this.CreateNewInfo();
                            return;
                        }
                    });
                    break;
                case 'Template':
                    //Info als Template anlegen
                    let newInfoId = Guid();
                    let objectModela = {
                        InfoTemplateId: newInfoId,
                        AreaID: this.AreaId(),
                        AreaName: this.AreaName(),
                        AreaEquipmentBinding: this.AreaEquipmentBinding(),
                        Device3NameBinding: this.Device3NameBinding(),
                        Device4NameBinding: this.Device4NameBinding(),
                        AreaEquipmentId: this.AreaEquipmentId(),
                        Device3Id: this.Device3Id(),
                        Device4Id: this.Device4Id(),
                        CategoryStructureId: this.CategoryStructureId(),
                        InfoText: this.InfoText(),
                        InfoStateId: this.InfoStateId(),
                        InfoLevelId: this.InfoLevelId(),
                        ShiftbookId: this.ShiftReport.ShiftbookId()
                    };
                    let infoTemplateTab = new TabPage();
                    infoTemplateTab.Url("MasterData/InfoTemplate");
                    infoTemplateTab.Route = { InitData: objectModela };
                    AppTabController.AddTab(infoTemplateTab);
                    break;
                case 'Mail':
                    let objectModelb = this.GetPrintModel();
                    this.SendReportMail(objectModelb.InfoId);
                    break;
                case 'Print':
                    let objectModelc = this.GetPrintModel();
                    this.PrintInfo(objectModelc.InfoId);
                    break;
                case 'CreateChecklist':
                    this.CreateChecklist();
                    break;
                case 'Notification':
                    this.ShowNotification();
                    break;
                case 'CreateTicket':
                    this.CreateTicket();
                    break;
                case 'CreateNotification':
                    this.CreateNotification();
                    break;
            }
        }
    };
    CreateNewInfo() {
        let infoTab = this.createNewInfoTab();
        if (infoTab) {
            this.CreateInfoTemplateDialog()
                .then(infoTemplateId => {
                    let newInfoId = Guid();
                    infoTab.InfoId = newInfoId;
                    infoTab.InfoTemplateId = infoTemplateId;
                    infoTab.IsNew = true;
                    this.loadTab(infoTab, true, newInfoId, null);
                });
        }
    }

    CreateInfoTemplateDialog = function () {
        this.TabPage.IsLoading(true);
        let def = $.Deferred();
        let infoTemplateDialog = new InfoTemplateDialog(this.TabPage);
        infoTemplateDialog.OpenDialog(this.ShiftReport.ShiftbookId())
            .then((infoTemplate: any) => {
                let infoTemplateId = null;
                if (infoTemplate != null) {
                    if (infoTemplate !== false) {
                        infoTemplateId = infoTemplate.InfoTemplateId;
                    }
                    def.resolve(infoTemplateId);
                }
                else {
                    def.reject();
                }
            });
        return def.promise();
    }



    GetPrintModel() {
        return {
            InfoId: this.InfoId(),
            StartDateHtml: this.StartDateHtml(),
            EndDateHtml: this.EndDateHtml(),
            AreaID: this.AreaId(),
            AreaName: this.AreaName(),
            AreaEquipmentBinding: this.AreaEquipmentBinding(),
            Device3NameBinding: this.Device3NameBinding(),
            Device4NameBinding: this.Device4NameBinding(),
            AreaEquipmentId: this.AreaEquipmentId(),
            Device3Id: this.Device3Id(),
            Device4Id: this.Device4Id(),
            CategoryStructureId: this.CategoryStructureId(),
            CategoryFullName: this.CategoryFullName(),
            InfoNr: this.InfoNr(),
            InfoText: this.InfoText(),
            InfoStateId: this.InfoStateId(),
            InfoStateText: this.InfoStateText(),
            InfoLevelId: this.InfoLevelId(),
            InfoLevelText: this.InfoLevelText(),
            Text: this.InfoText()
        };
    }
    PrintInfo(modelId) {
        if (this.TabPage.DirtyFlag()) {
            let saveInfo = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgNotSavedInfo"), "info");
            return;
        }
        return Bao.post('Information/PrintInfo', JSON.stringify({
            modelId: modelId,
            reportId: this.ShiftReport.ReportId(),
            reportName: this.ShiftReport.ReportShortTitle()
        })).then((result) => {
            if (result.IsCreated == true) {
                window.open(Bao.Content("BaoDocument/Download/" + result.Message), "_blank");
            }
            else if (result.IsCreated == false) {
                new BaoDialogViewModel(Bao.Session.ApplicationName, result.Message, "info");
            }
        });
    }
    SendReportMail(modelId) {
        if (this.TabPage.DirtyFlag()) {
            let saveInfo = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgNotSavedInfo"), "info");
            return;
        }
        this.TabPage.IsLoading(true);
        let dialog = new SendMailDialog(this, modelId, '');
        dialog.DialogInformation();
    }
    CreateChecklist() {
        if (this.TabPage.DirtyFlag()) {
            let saveInfo = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgNotSavedInfo"), "info");
            return;
        }
        else {
            var reportId = this.ShiftReport.ReportId();
            var tbPage = (<any>this.TabPage);
            tbPage.ReportViewModel = this.ShiftReport;
            var count = 0;
            return Bao.post("Dialog/GetInfoChecklistsByShiftbookId", JSON.stringify({
                shiftbookId: this.ShiftReport.ShiftbookId()
            }), (result) => {
                if (result != null) {
                    count = result.length;
                }
                if (count === 1) {
                    this.CreateEvaluation(result[0], reportId, tbPage);
                }
                else {
                    window.baorequire(['ViewModels/Dialogs/CreateEvaluationDialog'], (vm) => {
                        var dialog = new vm(tbPage, tbPage);
                        dialog.Show();
                        dialog.DialogResult.subscribe((dialogResult) => {
                            if (dialogResult == true) {
                                this.CreateEvaluation(dialog.DialogViewModel.FolderStructureChecklistId(), reportId, tbPage);
                            }
                        });
                    });
                }
            });
        }
    }
    CreateEvaluation(folderStructureChecklistId, reportId, tbPage) {
        tbPage.IsLoading(true);
        //TODO
        return Bao.post("EvaluationTab/CreateEvaluationByReport", JSON.stringify({
            folderStructureChecklistId: folderStructureChecklistId,
            reportId: reportId,
            infoId: this.InfoId()
        }), function (result) {
            if (result != false) {
                baoRouter.setHash("checkware/evaluation/" + result);
            }
            tbPage.IsLoading(false);
        });
    }
    ;
    CreateTicket() {
        if (this.TabPage.DirtyFlag()) {
            let saveInfo = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgNotSavedInfo"), "info");
            return;
        }
        else {
            var reportId = this.ShiftReport.ReportId();
            var infoId = this.InfoId();
            return Bao.post("Information/GetInformation", JSON.stringify({
                reportId: reportId,
                infoId: infoId,
                isOriginal: false
            }), (result) => {
                let newTicketTab = new TabPage('NewTicket');
                newTicketTab.IsClosable(true);
                newTicketTab.AutoSelect = true;
                newTicketTab.PreLoad(true);
                newTicketTab.Visible(true);
                newTicketTab.Url('Ticket/Index');
                newTicketTab.UrlData({
                    infoId: result.InfoId,
                    problemText: result.InfoText
                });
                AppTabController.AddTab(newTicketTab);
            });
        }
    }
    ShowNotification() {
        this.TabPage.IsLoading(true);
        var reportId = this.ShiftReport.ReportId();
        var tbPage = (<any>this.TabPage);
        tbPage.ReportViewModel = this.ShiftReport;
        window.baorequire(['ViewModels/Dialogs/InfoSapDialog'], (vm) => {
            var dialog = new vm(tbPage);
            dialog.Show(this.InfoId());
            this.TabPage.IsLoading(false);
        });
    }
    createNewInfoTab() {
        let newTab = this.ShiftReport.TabViewModel.SearchTabByObjectId('ActiveInfo');
        if (!newTab) {
            newTab = new TabPage('ActiveInfo');
            newTab.AutoSelect = false;
            newTab.Url('Information/Detail');
            newTab.UrlData({
                id: (<any>this.TabPage).FormHistoryId,
                reportId: this.ShiftReport.ReportId(),
                shiftbookId: this.ShiftReport.ShiftbookId()
            });
            newTab.IsClosable(true);
            newTab.PreLoad(true);
            newTab.Visible(true);
            newTab.FormHistoryId = (<any>this.TabPage).FormHistoryId;
            newTab.InformationTab = this;
            newTab.AlreadyLoaded = false;
            this.ShiftReport.TabViewModel.AddTab(newTab);
        }
        return newTab;
    }
    ;
    loadTab(tab, isNew, infoId, listIndex) {
        this.ShiftReport.TabViewModel.SelectTab(tab);
        if (tab.AlreadyLoaded) {
            let tabViewModel = tab.ViewModel();
            tabViewModel.BeforeClose(() => {
                tab.IsNew = isNew;
                tab.InfoId = infoId;
                tab.ListIndex = listIndex;
                tabViewModel.init()
                    .then(tabViewModel.loaded.bind(this)).then(() => {
                        tabViewModel.PagingEnabled(true);
                        this.ShiftReport.TabViewModel.SelectTab(tabViewModel.TabPage);
                        tabViewModel.toggleButtons();
                        tabViewModel.setTabTitle();
                    });
            }, true);
        }
        else {
        }
    }
    ;
    InitInfoModel(infoTemplateId) {
        return this.ResetSession()
            .then(() => {
                return Bao.post('Information/GetFromTemplate', JSON.stringify({
                    id: (<any>this.TabPage).FormHistoryId,
                    reportId: this.ShiftReport.ReportId(),
                    isOriginal: this.ShiftReport.IsOriginal.peek(),
                    infoTemplateId: ko.unwrap(infoTemplateId)
                })).then((result) => {
                    ko.map.fromJS(result, this, this.TabPage.DirtyFlag);
                });
            });
    }
    ;
    init() {
        this.TabPage.IsLoading(true);
        Bao.post("Information/CheckUseAddEventDialog").then((result) => {
            this.SystemSettingNotifyWhenAddEventToClosedReport(result);
        });
        // InfoId aus Informationsliste
        if ((<any>this.TabPage).IsNew == false) {
            this.InfoId((<any>this.TabPage).InfoId);
            (<any>this.TabPage).InfoId = null;
            return $.when(this.get(this.ShiftReport.IsOriginal.peek()), this.getPriorities(), this.getStates(), this.getCategories());
        }
        else {
            let def = $.Deferred();

            this.InfoId((<any>this.TabPage).InfoId);
            const infoTemplateId = (<any>this.TabPage).InfoTemplateId;
            (<any>this.TabPage).InfoId = null;
            (<any>this.TabPage).InfoTemplateId = null;

            this.InitInfoModel(infoTemplateId)
                .then(() => {
                    return $.when(this.getPriorities(), this.getStates(), this.getCategories())
                        .then(() => { def.resolve(); });
                }).fail(() => { def.reject(); });

            return def.promise();
        }
    }
    ;
    // a normal class function do not work, because the *this* context is not set correct in special cases
    loaded = () => {
        let def = $.Deferred();
        this.dispose();
        (<any>this.TabPage).AlreadyLoaded = true;
        this.PermissionPrefix = 'action' + this.ShiftReport.FormName() + 'CustomToolbarActiveInfo';
        //
        // Subscribe auf Berichtabschluss
        this.subscribe(this.ShiftReport.IsClosed, (isClosed) => {
            this.toggleButtons();
        });
        this.StartDateHtml["Formatted"] = ko.pureComputed(() => {
            if (this.StartDateHtml()) {
                return moment(this.StartDateHtml(), Bao.Utils.DateTimeFormat).format(Bao.Utils.DateTimeDisplayFormat);
            }
            else {
                return '';
            }
        });
        this.EndDateHtml["Formatted"] = ko.pureComputed(() => {
            if (this.EndDateHtml() && ko.unwrap(this.IsNew) == false) {
                return moment(this.EndDateHtml(), Bao.Utils.DateTimeFormat).format(Bao.Utils.DateTimeDisplayFormat);
            }
            else {
                return '';
            }
        });
        //
        // Calculate Duration
        this.StartDateHtml.subscribe((startDate) => {
            this.Duration(this.calculateDuration(startDate, null));
        });
        this.EndDateHtml.subscribe((endDate) => {
            this.Duration(this.calculateDuration(null, endDate));
        });
        this.Duration(this.calculateDuration());
        this.InitializeDateTimePicker();
        this.setTabTitle();
        this.subscribe(this.CategoryStructureId, (categoryStructureId) => {
            this.getStates();
        });
        this.refreshUserTagging();
        this.TabPage.DirtyFlag(false);
        this.TabPage.IsLoading(false);
        this.Focus();
        this.IgnoreDeviceChanges(false);
        this.registryNotifyInfoChangedHandler();
        def.resolve();
        return def.promise();
    };
    //
    // setzt erweiterte Einstellungen/Events auf den DatePicker-Controls
    InitializeDateTimePicker() {
        if (ko.unwrap(this.IsHistory) === true) {
            return; // es gbit keinen datepicker in history-version
        }
        let dpStart = $(this.ElementDateTimePickerStart()).parent().data("DateTimePicker");
        let dpEnd = $(this.ElementDateTimePickerEnd()).parent().data("DateTimePicker");
        dpStart.options({ useCurrent: false });
        dpEnd.options({ useCurrent: false });
        if (this.StartDateHtml && ko.unwrap(this.StartDateHtml)) {
            dpEnd.minDate(moment(ko.unwrap(this.StartDateHtml), Bao.Utils.DateTimeFormat));
        }
        if (this.EndDateHtml && ko.unwrap(this.EndDateHtml)) {
            dpStart.maxDate(moment(ko.unwrap(this.EndDateHtml), Bao.Utils.DateTimeFormat));
        }
        $(this.ElementDateTimePickerStart()).parent().on("dp.change", (e: any) => {
            dpEnd.minDate(e.date);
        });
        $(this.ElementDateTimePickerEnd()).parent().on("dp.change", (e: any) => {
            dpStart.maxDate(e.date);
        });
    }
    ;
    BeforeClose(fn, preventOverviewFocus) {
        if (this.TabPage.DirtyFlag() && this.SaveAllowed() && !this.IsHistory()) {
            this.shouldSave().then((shouldSave) => {
                if (shouldSave === true) {
                    this.validate().then((isValid) => {
                        if (isValid) {
                            this.checkThatShiftEventShouldBeTransferred()
                                .then((transferInfo: boolean | null) => {
                                    if (transferInfo === null) {
                                        return;
                                    }
                                    this.Save(transferInfo).then((saveResult) => {
                                        return this.afterSave(saveResult);
                                    })
                                        .then(() => {
                                            if ($.isFunction(fn)) {
                                                fn();
                                            }
                                            if (!preventOverviewFocus && preventOverviewFocus !== undefined) {
                                                this.ShiftReport.TabViewModel.SelectTab((<any>this.TabPage).InformationTab.TabPage);
                                            }
                                        });
                                });
                        } else {
                            this.showValidationErrors();
                        }
                    });
                }
                else if (shouldSave === false) {
                    if ($.isFunction(fn)) {
                        fn();
                    }
                    if (!preventOverviewFocus && preventOverviewFocus !== undefined) {
                        this.ShiftReport.TabViewModel.SelectTab((<any>this.TabPage).InformationTab.TabPage);
                    }
                }
                else {
                    //Save canceled
                }
            });
        }
        else {
            if ($.isFunction(fn)) {
                fn();
            }
            if (!preventOverviewFocus && preventOverviewFocus !== undefined) {
                this.ShiftReport.TabViewModel.SelectTab((<any>this.TabPage).InformationTab.TabPage);
            }
        }
    }

    // Berechnen der Dauer
    calculateDuration(startDate?, endDate?) {
        if (!startDate) {
            startDate = this.StartDateHtml();
        }
        if (!endDate) {
            endDate = this.EndDateHtml();
        }
        let startDateTime = moment(startDate, Bao.Utils.DateTimeFormat), endDateTime = moment(endDate, Bao.Utils.DateTimeFormat);
        if (startDateTime && endDateTime && startDateTime.isValid() && endDateTime.isValid()) {
            let dateDiff = endDateTime.subtract((<any>startDateTime));
            return dateDiff.hours() + ' Std.' + dateDiff.minutes() + ' Min.';
        }
        return '';
    }

    // Ein-/Ausblenden der Buttons
    toggleButtons() {

        // Backward/Forward
        if ((<any>this.TabPage).InformationTab != undefined && (<any>this.TabPage).InformationTab.TotalRows != undefined) {
            let totalRows = (<any>this.TabPage).InformationTab.TotalRows.peek();
            if ((<any>this.TabPage).IsNew || totalRows == 1 || this.IsHistory() || (<any>this.TabPage).ListIndex == null) {
                this.enableButton(this.PermissionPrefix + 'Backward', false);
                this.enableButton(this.PermissionPrefix + 'Forward', false);
            }
            else {
                if ((<any>this.TabPage).ListIndex == 0) {
                    this.enableButton(this.PermissionPrefix + 'Backward', false);
                    this.enableButton(this.PermissionPrefix + 'Forward', true);
                }
                else if ((<any>this.TabPage).ListIndex == (--totalRows)) {
                    this.enableButton(this.PermissionPrefix + 'Backward', true);
                    this.enableButton(this.PermissionPrefix + 'Forward', false);
                }
                else {
                    this.enableButton(this.PermissionPrefix + 'Backward', true);
                    this.enableButton(this.PermissionPrefix + 'Forward', true);
                }
            }
        }
        else {
            this.enableButton(this.PermissionPrefix + 'Backward', false);
            this.enableButton(this.PermissionPrefix + 'Forward', false);
        }

        // Save/Delete
        let canSave = (!this.IsHistory() && this.SaveAllowed());
        this.enableButton(this.PermissionPrefix + 'Save', canSave);
        this.enableButton(this.PermissionPrefix + 'Delete', canSave && !this.ShiftReport.IsClosed.peek());
        this.enableButton(this.PermissionPrefix + 'Info', this.HasHistory() && !this.IsNew());
        // send pdf as mail
        this.enableButton(this.PermissionPrefix + 'Mail', !this.IsNew());
        // create checklist 
        this.enableButton(this.PermissionPrefix + 'CreateChecklist', !this.IsNew());
        // create ticket 
        this.enableButton(this.PermissionPrefix + 'CreateTicket', !this.IsNew());
        // print pdf
        this.enableButton(this.PermissionPrefix + 'Print', !this.IsNew());
        // SAP notification enable/disable button
        if (this.InfoSapId() != null) {
            this.enableButton(this.PermissionPrefix + 'Notification', true);
            this.enableButton(this.PermissionPrefix + 'CreateNotification', false);
        }
        else {
            this.enableButton(this.PermissionPrefix + 'Notification', false);
            this.enableButton(this.PermissionPrefix + 'CreateNotification', !this.IsNew());
        }
    }
    ;
    setPermissions() {
        let permissions = this.ShiftReport.Permissions();
        if (!permissions)
            return;
        for (let actionKey in permissions) {
            this.baoToolbar2ShowButton(actionKey, permissions[actionKey]);
            if (this.baoToolbar2LinkItemsShowButton) {
                this.baoToolbar2LinkItemsShowButton(actionKey, permissions[actionKey]);
            }
            if (this.baoToolbar2InformationEvaluationShowButton) {
                this.baoToolbar2InformationEvaluationShowButton(actionKey, permissions[actionKey]);
            }
        }
    }
    disablePaging() {
        this.PagingEnabled(false);
        this.enableButton(this.PermissionPrefix + 'Backward', false);
        this.enableButton(this.PermissionPrefix + 'Forward', false);
        this.setTabTitle();
    }
    ;
    //
    // Titel des Tabs aktualisieren
    setTabTitle() {
        this.TabPage.Title(this.TabName());
        //if (this.TabPage.IsNew) {
        //    this.TabPage.Title('Neues Ereignis');
        //} else if (this.IsHistory()) {
        //    this.TabPage.Title('Ereignis ' + this.InfoNr() + ' (Revision ' + this.Revision() + ')');
        //} else {
        //    if (this.TabPage.ListIndex !== null && !isNaN(this.TabPage.ListIndex) && this.PagingEnabled()) {
        //        this.TabPage.Title('Ereignis ' + this.InfoNr() + ' (' + (this.TabPage.ListIndex + 1) + ' / ' + this.TabPage.InformationTab.TotalRows() + ')');
        //    } else {
        //        this.TabPage.Title('Ereignis ' + this.InfoNr());
        //    }
        //}
    }
    ;
    //
    // Fetch Prioritäten
    getPriorities() {
        return Bao.post('Information/GetPriorities', JSON.stringify({
            id: (<any>this.TabPage).FormHistoryId
        })).then((result) => {
            ko.map.fromJS(result, this.Priorities);
        });
    }
    ;
    //
    // Fetch Stati
    getStates() {
        return Bao.post('Information/GetStates', JSON.stringify({
            id: (<any>this.TabPage).FormHistoryId,
            reportId: this.ShiftReport.ReportId(),
            categoryStructureId: ko.isObservable(this.CategoryStructureId) ? this.CategoryStructureId() : null
        })).then((result) => {
            ko.map.fromJS(result, this.States);
        });
    }
    ;
    //
    // Fetch Kategorien
    getCategories() {
        return Bao.post('Information/GetCategories', JSON.stringify({
            id: (<any>this.TabPage).FormHistoryId,
            shiftbookId: this.ShiftReport.ShiftbookId()
        })).then((result) => {
            ko.map.fromJS(result, this.Categories);
        });
    }
    ;

    getInfoTags() {
        return Bao.post('Information/GetInfoTags', JSON.stringify({
            phrase: '',
            infoId: this.InfoId()
        })).then((result) => ko.map.fromJS(result, this.InfoTags));
    }

    
    // Fetch Information
    get(isOriginal, isLatestRevision = false) {
        // vor dem Get unbedingt session clearen
        return this.ResetSession()
            .then(() => this.getInfoTags())
            .then(() => {
                return Bao.post('Information/Get', JSON.stringify({
                    id: (<any>this.TabPage).FormHistoryId,
                    reportId: this.ShiftReport.ReportId(),
                    infoId: this.InfoId(),
                    isOriginal: isOriginal,
                    isShiftClosure: isLatestRevision ? false : this.ShiftReport.IsShiftClosure()
                }));
            })
            .fail(() => {
                //fail occurs, if server response 403 (restricted access e.g. RoleArea) or 410 (removed) or some other error code...
                // on failure a dialog will appear by default and this tabpage should be closed
                (<any>this.TabPage).$TabController.RemoveTab(this.TabPage);
            })
            .then((result) => {
                ko.map.fromJS(result, this, this.TabPage.DirtyFlag);
                this.TabPage.DirtyFlag.reset();               
                return $.Deferred().resolve().promise();
            });
    };

    //
    // Schließen des Tabs möglich?
    canClose() {
        let result = $.Deferred<boolean>();
        if (this.IsHistory()) {
            result.resolve(true);
        }
        else {
            if (this.TabPage.DirtyFlag() && this.SaveAllowed()) {
                result.resolve(false);
            }
            else {
                result.resolve(true);
            }
        }
        return result.promise();
    }
    ;
    //
    // Wollen Sie die Information wirklich speichern?
    shouldSave() {
        let deferred = $.Deferred();
        if (this.ShiftReport?.Permissions()?.actionFormShiftReportCustomToolbarActiveInfoSave) {
            let dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.SaveCheck), 'question');
            dialog.DialogResult.subscribe((saveInformation) => {
                if (saveInformation === true) {
                    this.validateDate().then(res => {
                        if (res.Value === true) {
                            deferred.resolve(saveInformation);
                        } else {
                            new BaoDialog(Bao.Session.ApplicationName, res.Message, "info");
                            deferred.resolve();
                        }
                    })
                } else {
                    deferred.resolve(saveInformation);
                }
            });
        }
        else {
            deferred.resolve(false);
        }
        return deferred.promise();
    }
    ;
    //
    // Validieren der Benutzereingaben
    validate() {
        return this.CompleteCheck()
            .then((isValid) => {
                if (isValid === false) {
                    return isValid;
                }
                // check Tab's CompleteCheckFunctions
                return $.when.call(this, this.SubTabsCompleteCheckFn.map((fn) => {
                    if (typeof fn === "function") {
                        return fn();
                    } return fn;
                }))
                    .then((res) => {
                        if (typeof res.length === "undefined") {
                            return res;
                        }
                        else {
                            for (let ind in res) {
                                if (res[ind] === false) {
                                    return false;
                                }
                            }
                            return true;
                        }
                    });
            });
    }
    ;
    CompleteCheck() {
        this.TabPage.IsLoading(true);
        return Bao.post('Information/Validate', JSON.stringify({
            id: (<any>this.TabPage).FormHistoryId,
            infoModel: ko.map.toJS(this, true),
            shiftbookId: this.ShiftReport.ShiftbookId()
        }), () => {
            this.TabPage.IsLoading(false);
        });
    }

    checkThatShiftEventShouldBeTransferred(): JQueryPromise<boolean | null> {
        let deferred = $.Deferred<boolean>();
        if (!this.IsNew()) {
            return deferred.resolve(false).promise();
        }

        this.TabPage.IsLoading(true);
        let infoModel = ko.map.toJS(this, true);
        infoModel.InfoTag = ko.map.toJS(this.InfoTag);

        Bao.post('Information/ShiftEventShouldBeTransferred', JSON.stringify({
            reportId: this.ReportId(),
            infoModel: infoModel
        }), (shouldBeTransfered) => {
            this.TabPage.IsLoading(false);
            if (shouldBeTransfered) {
                let dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage('msgMoveNewShiftEventToNextOpenReport'), 'yesno');
                dialog.DialogResult.subscribe((dialogResult) => {
                    if (dialogResult === true) {
                        deferred.resolve(true);
                    }
                    else {
                        deferred.resolve(null);
                    }
                });
            }
            else {
                deferred.resolve(false);
            }
        });

        return deferred.promise();
    }


    //
    // Information speichern
    Save(transferInfo: boolean) {
        if (!this.TabPage.DirtyFlag() && !this.IsNew()) {
            //check again for the closing of the report to avoid a revision 
            return;
        }
        let infoModel = ko.map.toJS(this, true);
        infoModel.InfoAttachment = ko.map.toJS(this.InfoAttachment);
        infoModel.InfoTag = ko.map.toJS(this.InfoTag);
        let saveResult;
        this.TabPage.IsLoading(true);
        return Bao.post("Information/Save", JSON.stringify({
            id: (<any>this.TabPage).FormHistoryId,
            infoModel: infoModel,
            transferToNextOpenReport: transferInfo
        })).then((data) => {
            saveResult = data;
            // check if tab with linked items is available and call his save fn
            let defs = [];
            if (typeof this.SubTabsSaveFn !== "undefined" && this.SubTabsSaveFn != null) {
                this.SubTabsSaveFn.forEach((saveFn) => {
                    if (typeof saveFn === "function") {
                        defs.push(saveFn());
                    }
                });
            }
            Bao.raiseEvent('user-tagging:save', { entityId: this.InfoId()});
            // return promise which is resolved when all saveFn are resolved
            return $.when.apply(this, defs);
        }).then(() => {
            this.TabPage.IsLoading(false);
            return saveResult;
        });
    }
    ;
    //
    // Information
    afterSave(saveResult) {
        let deferred = $.Deferred();
        if (saveResult) {
            this.showAlert(finitoService.MessageKeys.InfoSaveSuccessful);
            this.TabPage.DirtyFlag(false);
            if ((<any>this.TabPage).IsNew) {
                (<any>this.TabPage).IsNew = false;
            }
            // refetch nach Speichern im Original-Modus
            // TODO 
            if (this.ShiftReport.IsOriginal.peek()) {
                this.ShiftReport.IsOriginal(false);
                this.ShiftReport.IsShiftClosure(false);
            }
            this.get(this.ShiftReport.IsOriginal.peek()).then(() => {
                this.TabPage.IsLoading(false);
                this.toggleButtons();
                this.setTabTitle();
                deferred.resolve(saveResult);
            });
        }
        else {
            this.showAlert(finitoService.MessageKeys.InfoSaveError);
            this.TabPage.IsLoading(false);
            deferred.resolve(saveResult);
        }
        // lässt die liste der informationen aktualisieren
        Bao.raiseEvent('informations:refresh', { ReportId: this.ReportId() });
        return deferred.promise();
    }
    ;
    //
    // Information löschen
    delete() {
        let dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.InfoDeleteQuestion), 'yesno');
        dialog.DialogResult.subscribe((canDelete) => {
            if (canDelete) {
                this.TabPage.IsLoading(true);
                if (this.IsNew()) {
                    this.showAlert(finitoService.MessageKeys.InfoDeleteSuccessful);
                    (<any>this.TabPage).InformationTab.getInfos();
                    this.TabPage.DirtyFlag(false);
                    (<any>this.TabPage).InformationTab.returnToMyself(this.TabPage);
                }
                else {
                    return Bao.post('Information/Delete', JSON.stringify({
                        id: (<any>this.TabPage).FormHistoryId,
                        reportId: this.ShiftReport.ReportId(),
                        infoIds: [this.InfoId()]
                    })).then((deleted) => {
                        if (deleted > 0) {
                            this.showAlert(finitoService.MessageKeys.InfoDeleteSuccessful);
                            (<any>this.TabPage).InformationTab.getInfos();
                            (<any>this.TabPage).InformationTab.returnToMyself(this.TabPage);
                        }
                        else {
                            this.showAlert(finitoService.MessageKeys.InfoDeleteError, 'danger');
                        }
                        this.TabPage.IsLoading(false);
                    });
                }
            }
        });
    }
    ;
    //
    // Zur nächsten Information navigieren
    forward() {
        this.navigate(() => {
            this.TabPage.IsLoading(true);
            (<any>this.TabPage).ListIndex = ++(<any>this.TabPage).ListIndex;
            (<any>this.TabPage).InformationTab.GetInfoForPaging((<any>this.TabPage).ListIndex).then((nextInfo) => {
                if (nextInfo) {
                    this.InfoId(ko.utils.unwrapObservable(nextInfo.InfoId));
                    this.get(this.ShiftReport.IsOriginal.peek()).then(this.loaded.bind(this)).then(() => {
                        this.ShiftReport.TabViewModel.SelectTab(this.TabPage);
                        this.toggleButtons();
                    });
                }
                else {
                    this.TabPage.IsLoading(false);
                }
            });
        });
    }
    ;
    //
    // Zur vorherigen Information navigieren
    backward() {
        this.navigate(() => {
            this.TabPage.IsLoading(true);
            (<any>this.TabPage).ListIndex = --(<any>this.TabPage).ListIndex;
            (<any>this.TabPage).InformationTab.GetInfoForPaging((<any>this.TabPage).ListIndex).then((nextInfo) => {
                if (nextInfo) {
                    this.InfoId(ko.utils.unwrapObservable(nextInfo.InfoId));
                    this.get(this.ShiftReport.IsOriginal.peek()).then(this.loaded.bind(this)).then(() => {
                        this.ShiftReport.TabViewModel.SelectTab(this.TabPage);
                        this.toggleButtons();
                    });
                }
                else {
                    this.TabPage.IsLoading(false);
                }
            });
        });
    }
    ;
    //
    // Zur vorherigen/nächsten Information navigieren
    navigate(navigate) {
        if (!this.IsHistory()) {
            if (this.TabPage.DirtyFlag() && this.SaveAllowed()) {
                this.shouldSave().then((shouldSave) => {
                    if (shouldSave === true) {
                        this.validate().then((isValid) => {
                            if (isValid) {
                                this.checkThatShiftEventShouldBeTransferred()
                                    .then((transferInfo: boolean | null) => {
                                        if (transferInfo === null) {
                                            return;
                                        }
                                        this.Save(transferInfo).then((saveResult) => {
                                            this.afterSave(saveResult);
                                        }).then(() => {
                                            navigate();
                                        });
                                    });
                            }
                            else {
                                this.showValidationErrors();
                            }
                        });
                    }
                    else if (shouldSave === false) {
                        navigate();
                    }
                    else {
                        //Cancelled
                    }
                });
            }
            else {
                navigate();
            }
        }
        else {
            navigate();
        }
    }
    ;
    //
    // Fetch InfoHistory
    getHistory(historyItem) {
        this.BeforeClose(() => {
            if (historyItem) {
                if (historyItem.IsNewestRevision()) {
                    this.TabPage.IsLoading(true);
                    this.get(historyItem.IsOriginal(), historyItem.IsNewestRevision()).then(() => {
                        if (this.TextModuleField() != undefined) {
                            finitoService.setTextToUserTaggingInput(this.TextModuleField().querySelector("#userTaggingInput"), historyItem.InfoText(),
                                false)
                        }
                        this.toggleButtons();
                        this.setTabTitle();
                        this.TabPage.IsLoading(false);
                    });
                }
                else {
                    this.TabPage.IsLoading(true);
                    Bao.post('Information/GetHistory', JSON.stringify({
                        id: (<any>this.TabPage).FormHistoryId,
                        infoHistoryId: historyItem.InfoHistoryId()
                    })).then((result) => {
                        ko.map.fromJS(result, this, this.TabPage.DirtyFlag);
                        if (this.TextModuleField() != undefined && result != undefined) {

                            finitoService.setTextToUserTaggingInput(this.TextModuleField().querySelector("#userTaggingInput"), result.InfoText, result.IsHistory)
                        }

                        this.toggleButtons();
                        this.setTabTitle();
                        this.TabPage.DirtyFlag.reset();
                        this.TabPage.IsLoading(false);
                    });
                }
            }
        }, true);
    }
    ;
    //
    // Historie anzeigen
    info() {
        Bao.get('Information/History', $.param({
            id: (<any>this.TabPage).FormHistoryId,
            infoId: this.InfoId(),
            reportId: this.ShiftReport.ReportId()
        })).then((html) => {
            let dialog = new BaoDialog(Bao.Session.GetMessage('msgHistory'));
            dialog.ViewModel(new InformationHistoryViewModel((<any>this.TabPage).FormHistoryId, this.InfoId(), (historyItem) => {
                this.getHistory(historyItem);
                dialog.Close();
            }));
            dialog.Template(html);
            dialog.Buttons([
                {
                    Title: Bao.Session.GetMessage("msgOk"),
                    Click: () => {
                        if (dialog.ViewModel().Selection()) {
                            this.getHistory(dialog.ViewModel().Selection()[0]);
                        }
                        dialog.Close();
                    },
                    Enabled: dialog.ViewModel().HasSelection,
                    IsDefault: ko.observable(false),
                    Focus: () => { }
                },
                {
                    Title: Bao.Session.GetMessage("msgCancel"),
                    Click: () => {
                        dialog.Close();
                    },
                    Enabled: ko.observable(true),
                    IsDefault: ko.observable(false),
                    Focus: () => { }
                }
            ]);
            dialog.ViewModel().initialize();
            dialog.Open();
        });
    }
    ;
    SetParentsByDevice4() {
        let def = $.Deferred();
        if (this.IgnoreDeviceChanges() == false) {
            if (this.Device4Id() != null) {
                this.TabPage.IsLoading(true);
                this.IgnoreDeviceChanges(true);
                Bao.post("Device/Device4Parents", JSON.stringify({ device4Id: this.Device4Id(), shiftbookId: this.ShiftReport.ShiftbookId() }), (result) => {
                    if (result != null) {
                        if (result.Device3Id != null && this.Device3Id() == null && Bao.Utils.String.IsNullOrWhitespace(this.Device3NameBinding())) {
                            this.Device3Id(result.Device3Id);
                            this.Device3NameBinding(result.Device3Name);
                        }
                        if (result.AreaEquipmentId != null && this.AreaEquipmentId() == null && Bao.Utils.String.IsNullOrWhitespace(this.AreaEquipmentBinding())) {
                            this.AreaEquipmentId(result.AreaEquipmentId);
                            this.AreaEquipmentBinding(result.AreaEquipmentName);
                        }
                        if (result.AreaId != null && this.AreaId() == null && Bao.Utils.String.IsNullOrWhitespace(this.AreaName())) {
                            this.AreaId(result.AreaId);
                            this.AreaName(result.AreaName);
                        }
                    }
                }).always(() => {
                    this.TabPage.IsLoading(false);
                    this.IgnoreDeviceChanges(false);
                    def.resolve();
                });
            }
            else {
                //device 4 deleted
                def.resolve();
            }
        }
        else {
            def.resolve();
        }
        return def.promise();
    }
    ;
    SetParentsByDevice3() {
        let def = $.Deferred();
        if (this.IgnoreDeviceChanges() == false) {
            this.IgnoreDeviceChanges(true);
            if (this.Device3Id() != null) {
                this.TabPage.IsLoading(true);
                $.when(Bao.post("Device/Device3Parents", JSON.stringify({ device3Id: this.Device3Id(), shiftbookId: this.ShiftReport.ShiftbookId() }), (result) => {
                    if (result != null) {
                        if (result.AreaEquipmentId != null && this.AreaEquipmentId() == null && Bao.Utils.String.IsNullOrWhitespace(this.AreaEquipmentBinding())) {
                            this.AreaEquipmentId(result.AreaEquipmentId);
                            this.AreaEquipmentBinding(result.AreaEquipmentName);
                        }
                        if (result.AreaId != null && this.AreaId() == null && Bao.Utils.String.IsNullOrWhitespace(this.AreaName())) {
                            this.AreaId(result.AreaId);
                            this.AreaName(result.AreaName);
                        }
                    }
                }), Bao.post("Device/Device3Children", JSON.stringify({ device3Id: this.Device3Id(), device4Id: this.Device4Id() }), (result) => {
                    if (result != null) {
                        if (result.Device4 == false) {
                            this.Device4Id(null);
                            this.Device4NameBinding(null);
                        }
                    }
                })).always(() => {
                    this.TabPage.IsLoading(false);
                    this.IgnoreDeviceChanges(false);
                    def.resolve();
                });
            }
            else {
                //Device3 deleted
                this.Device4Id(null);
                this.Device4NameBinding(null);
                this.IgnoreDeviceChanges(false);
                def.resolve();
            }
        }
        else {
            def.resolve();
        }
        return def.promise();
    }
    ;
    SetParentsByAreaEquipment() {
        let def = $.Deferred();
        if (this.IgnoreDeviceChanges() == false) {
            this.IgnoreDeviceChanges(true);
            if (this.AreaEquipmentId() != null) {
                this.TabPage.IsLoading(true);
                $.when(Bao.post("Device/AreaEqupimentParents", JSON.stringify({ areaEquipmentId: this.AreaEquipmentId(), shiftbookId: this.ShiftReport.ShiftbookId() }), (result) => {
                    if (result != null) {
                        if (result.AreaId != null && this.AreaId() == null && Bao.Utils.String.IsNullOrWhitespace(this.AreaName())) {
                            this.AreaId(result.AreaId);
                            this.AreaName(result.AreaName);
                        }
                    }
                }), Bao.post("Device/AreaEquipmentChildren", JSON.stringify({ areaEquipmentId: this.AreaEquipmentId(), device3Id: this.Device3Id(), device4Id: this.Device4Id() }), (result) => {
                    if (result != null) {
                        if (result.Device3 == false) {
                            this.Device3Id(null);
                            this.Device3NameBinding(null);
                        }
                        if (result.Device4 == false) {
                            this.Device4Id(null);
                            this.Device4NameBinding(null);
                        }
                    }
                })).always(() => {
                    this.TabPage.IsLoading(false);
                    this.IgnoreDeviceChanges(false);
                    def.resolve();
                });
            }
            else {
                //AreaEquipment deleted
                this.Device3Id(null);
                this.Device3NameBinding(null);
                this.Device4Id(null);
                this.Device4NameBinding(null);
                this.IgnoreDeviceChanges(false);
                def.resolve();
            }
        }
        else {
            def.resolve();
        }
        return def.promise();
    }
    ;
    SetChildrenByArea() {
        let def = $.Deferred();
        if (this.IgnoreDeviceChanges() == false) {
            this.IgnoreDeviceChanges(true);
            if (this.AreaId() != null) {
                this.TabPage.IsLoading(true);
                Bao.post("Device/AreaChildren", JSON.stringify({ areaId: this.AreaId(), areaEquipmentId: this.AreaEquipmentId(), device3Id: this.Device3Id(), device4Id: this.Device4Id() }), (result) => {
                    if (result != null) {
                        if (result.AreaEquipment == false) {
                            this.AreaEquipmentId(null);
                            this.AreaEquipmentBinding(null);
                        }
                        if (result.Device3 == false) {
                            this.Device3Id(null);
                            this.Device3NameBinding(null);
                        }
                        if (result.Device4 == false) {
                            this.Device4Id(null);
                            this.Device4NameBinding(null);
                        }
                    }
                }).always(() => {
                    this.TabPage.IsLoading(false);
                    this.IgnoreDeviceChanges(false);
                    def.resolve();
                });
            }
            else {
                this.AreaEquipmentBinding(null);
                this.AreaEquipmentId(null);
                this.Device3Id(null);
                this.Device3NameBinding(null);
                this.Device4Id(null);
                this.Device4NameBinding(null);
                this.IgnoreDeviceChanges(false);
                def.resolve();
            }
        }
        return def.promise();
    }
    ;
    // Schichtinformation an SAP-PM melden 
    CreateNotification() {
        var tabPage = this.TabPage;
        var self = this;
        tabPage.IsLoading(true);
        var notifCreated = false;
        var infoId = this.InfoId();
        Bao.post("Information/CheckInfoSap", JSON.stringify({
            infoId: infoId
        }), function (result) {
            notifCreated = result.Message;
            if (!notifCreated) {
                window.baorequire(['ViewModels/Dialogs/InfoSapDialog'], function (vm) {
                    var dialog;
                    if (infoId != null) {
                        dialog = new vm(tabPage);
                        dialog.Show(infoId, tabPage);
                        dialog.DialogResult.subscribe((dlgResult) => {

                            if (dlgResult === true) {

                                self.get(this.ShiftReport?.IsOriginal.peek()).then(() => { self.toggleButtons(); Bao.raiseEvent("infoSapTab:refresh", null); }).always(() => {
                                    tabPage.IsLoading(false);

                                });


                            }
                            tabPage.IsLoading(false);
                        });
                    }
                });
            }
            else {
                var baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgSapExist"), "info");
            }
        });
    }
    ;
    dispose() {
        MessageBus.unsubscribe([this.notifyInfoChangedHandler]);
    }
    ;
    private registryNotifyInfoChangedHandler = () => {
        MessageBus.subscribe([this.notifyInfoChangedHandler])
            .catch(() => {
                console.warn('Cannot connect to MessageBus');
            });
    };
    private checkAndShowNotifyIfRecordChanged = (id: string, syncId: number, excludeUserId: string) => {
        if (this.SyncId() !== syncId && String(this.InfoId()).toLowerCase() === id.toLowerCase() && excludeUserId !== ko.unwrap(Bao.Session.User.UserId)) {
            this.showAlert('msqRecordHasBeenChanged', 'warning', -1);
        }
    };
    private refreshUserTagging() {
        this.showUserTaggingControl(false);
        this.showUserTaggingControl(true);
    }
    private checkUserTaggingValue(id) {
        // Insert original user tagging value if needed
        if ((this.ShiftReport?.IsOriginal() && id == this.InfoId()) || (this.ShiftReport?.IsShiftClosure() && id == this.InfoId())) {
            if (this.TextModuleField() != undefined) {
                finitoService.setTextToUserTaggingInput(this.TextModuleField().querySelector("#userTaggingInput"), this.InfoText(), true);
            }            
        }
    }
}
export default InformationViewModel;
//});